<template>
    <div class="igc-ad">
        <div class="sui-swiper" v-if="mossAds.length == 1">
            <ul style="width: 100%;">
                <li style="width: 100%;">
                        <a href="javascript:;" :style="'background-image:url('+mossAds[0].images+')'" @click.stop="report(mossAds[0])">
                        <div class="ig--title">{{mossAds[0].title}}</div>
                    </a>
                </li>
            </ul>
        </div>
        <sui-swiper v-if="mossAds.length > 1" key-name="id" :list="mossAds" :autoPlay="true" @change="changeSwiper">
            <template #default="{ item }">
                <a href="javascript:;" :style="'background-image:url('+item.images+')'" @click.stop="report(item)">
                    <div class="ig--title">{{item.title}}</div>
                </a>
            </template>
        </sui-swiper>
    </div>
</template>

<script>
let isTest = '';
if (sessionStorage.igEnv == 'development') {
    isTest = 'test_';
}
import { loadScript } from '../../scripts/utils/index'
import mCore from '../../scripts/mixins/core'
import axios from "axios"

export default {
    name: 'igc-ad',
    data:function(){
        return {
            mossAds:[],
            curIndex:0,
            hasReport:[],
        }
    },
    mixins: [mCore],

    props: {
        id: {
            type: String,
            required: true
        }
    },

    computed: {
        indexConfig() {
            return this.$store.state.global.config.navigators.index
        }, 
        game() {
            return this.$store.state.global.game
        }
    },
    
    mounted() {
        this.renderAd()
    },

    methods: {
        changeSwiper(index) {
            if(this.curIndex != index){
                if(this.hasReport.indexOf(index) === -1){
                    this.hasReport.push(index);
                    this.mEventTrackingToMosso('pop','bannermoss-'+this.indexConfig.banner_id+'-'+this.mossAds[index].id,'moss广告图'+this.indexConfig.banner_id);
                }
            }
            this.curIndex = index
        },

        report(item) {
            this.mEventTrackingToMosso('link','bannermoss-'+this.indexConfig.banner_id+'-'+item.id,'moss广告图'+this.indexConfig.banner_id);
            setTimeout(()=>{
                if(!sessionStorage.tokenParams){
                    location.href = item.url
                }else{
                    location.href = item.url.indexOf('?') > -1 ? (item.url + sessionStorage.tokenParams.replace('?', '&')) : (item.url + sessionStorage.tokenParams)
                }
            },200)
        },

        idataBanner(){
            const render = () => {
                this.$el.innerHTML = `<script type="text/html" t-foreach="mydata" data-channels="${ this.id }">
                    <a class="idata-link" href="<% sessionStorage.tokenParams && _mydata.adUrl.indexOf('//sy.qq.com/${ this.game }/ingame/') < 0 ? (_mydata.adUrl.indexOf('?') > 0 ? _mydata.adUrl + sessionStorage.tokenParams.replace('?', '&') : _mydata.adUrl + sessionStorage.tokenParams) : _mydata.adUrl %>" style="background-image: url(<% _mydata.imgUrl.indexOf('?') < 0 ? _mydata.imgUrl + '?' : _mydata.imgUrl + '&' %>${ WD_MAX_AGE_MONTH })">
                        <div class="ig--title" t-watch="1"><% _mydata.Fname %></div>
                    </a>
                <\/script>`
                window.iData_New_Tplparser.run()
            }
            if (window.iData_New_Tplparser) {
                render()
            } else {
                loadScript(`https://ossweb-img.qq.com/images/clientpop/js/tgadshow.min.js?${ WD_MAX_AGE_WEEK }`).then(() => {
                    render()
                })
            }
        },

        renderAd() {
            if(this.indexConfig && this.indexConfig.banner_id){ //走moss平台的广告位
                axios.get('https://tiem-cdn.qq.com/moss/product/' + this.game + '/statics/operation/' + isTest + this.indexConfig.banner_id + '.json')
                .then(res => {
                    if(res.status === 200 && res.data){
                        if(Array.isArray(res.data)){
                            const nowtime = new Date().getTime()
                            res.data = res.data.filter(v => {   //过滤只有上线的状态才需要外显
                                return v.status == 2 || v.status == 3
                            })
                            this.mossAds = res.data.filter(v=>{
                                return new Date(v.start_time.replace(/-/g,'/')).getTime() <= nowtime && new Date(v.end_time.replace(/-/g,'/')).getTime() >= nowtime
                            })
                            setTimeout(()=>{
                                const list = document.querySelectorAll('.idata-link')
                                if(list.length > 0){
                                    for(let i=0;i<list.length;i++){
                                        list[i].style.display = 'none'
                                    }
                                }
                            },300)
                            if(this.mossAds.length > 0){
                                this.mEventTrackingToMosso('pop','bannermoss-'+ this.indexConfig.banner_id+'-'+this.mossAds[0].id,'moss广告图'+this.indexConfig.banner_id)  //默认第一个广告曝光上报 
                            }
                        }
                    }
                }).catch(()=>{
                    this.idataBanner()
                });
            }else{
                this.idataBanner()
            }
        }
    }
}
</script>

<style lang="postcss">
.igc-ad {
    box-sizing: border-box;
    overflow: hidden;
    height: 322px;
    margin-top: 20px;
    @media (orientation: portrait) {
        width: 100%;
    }
    @media (orientation: landscape) {
        width: calc((100% - 20px) / 2);
    }
    a {
        display: block;
        width: 100%;
        height: 100%;
        background: no-repeat center / cover;
        .ig--title {
            display: flex;
            align-items: flex-end;
            box-sizing: border-box;
            height: 100%;
            padding: 24px;
            font-size: 32px;
            color: #fff;
            background: linear-gradient(transparent, transparent 50%, #000);
        }
    }
}
</style>
